import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import Pill from "app/components/Pill";
import CheckboxIcon from "app/components/Icons/CheckboxIcon";
import { CheckboxActiveIcon } from "app/components/Icons";
import Actions from "./Actions";

interface MenusProps {
  opt: any;
  isSelected: boolean;
  handleSelect: (tag: any) => void;
  onDeleteRequest?: () => void;
}
const MenuTile: React.FC<MenusProps> = ({
  opt,
  isSelected,
  handleSelect,
  onDeleteRequest,
}) => {
  return (
    <DropdownMenu.Item
      key={opt._id}
      onSelect={(e) => e.preventDefault()}
      className="cursor-pointer hover:outline-none hover:bg-gray-400 px-4 py-3 flex items-center justify-between gap-2 w-full min-w-0 group"
    >
      <button
        className="flex flex-row items-center flex-1 min-w-0 gap-2"
        onClick={(e) => {
          e.stopPropagation();
          handleSelect(opt);
        }}
      >
        {isSelected ? (
          <CheckboxActiveIcon size={20} />
        ) : (
          <CheckboxIcon size={18} />
        )}
        <Pill
          backgroundColor={opt?.color}
          name={opt?.title}
          className="px-[6px] py-[2px] text-[10px] leading-[18px] font-medium max-w-[80%]"
        />
      </button>
      <div className="shrink-0">
        <Actions selectedData={opt} onDeleteRequest={onDeleteRequest} />
      </div>
    </DropdownMenu.Item>
  );
};

export default MenuTile;
